export default [
  {
    path: '/ac/findPwd',
    name: 'findPwd',
    component: () => import('@/pages/multi/findPsw/App.vue'),
    meta: {
      title: '找回密码',
    },
  },
];
